// extracted by mini-css-extract-plugin
module.exports = {"goodsTableWrap":"goodsTable_goodsTableWrap__3D8nP"};